// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"c6fffc69","703":"4fbff500"}[chunkId] + ".chunk.js";
};